import { useEffect, useState } from "react";
import { packageLimitsService, type PackageLimits } from "../services/packageLimitsService";
import { useDeploymentMode } from "./useDeploymentMode";

export function usePackageLimits() {
  const [limits, setLimits] = useState<PackageLimits | null>(null);
  const { onPrem, loading } = useDeploymentMode();

  useEffect(() => {
    // On-prem has no package limits: nothing is fetched and no limit hint is ever rendered.
    if (loading || onPrem) return;
    let cancelled = false;
    packageLimitsService
      .get()
      .then((data) => {
        if (!cancelled) setLimits(data);
      })
      .catch(() => {
        if (!cancelled) setLimits(null);
      });
    return () => {
      cancelled = true;
    };
  }, [loading, onPrem]);

  return onPrem ? null : limits;
}

export function formatLimitValue(
  value: number | null | undefined,
  unlimitedLabel: string
): string {
  if (value == null) return unlimitedLabel;
  return value.toLocaleString();
}

export function formatBytesMb(bytes: number | null | undefined, unlimitedLabel: string): string {
  if (bytes == null) return unlimitedLabel;
  const mb = bytes / (1024 * 1024);
  if (mb >= 10) return `${Math.round(mb)}`;
  return mb.toFixed(1).replace(/\.0$/, "");
}
